// extracted by mini-css-extract-plugin
export default {"GameHeading":"Games_GameHeading__sRIBc"};